import { fmtDuration } from "../lib/format";
import { HR_ZONE_RANGES, POWER_ZONE_RANGES, ZONE_COLORS } from "../lib/zones";

export const ZoneChart = ({
  zones,
  title = "Heart Rate Zones",
  eyebrow = "Distribution",
  type = "hr",
  testId,
}) => {
  if (!zones) return null;
  const total = Object.values(zones).reduce((a, b) => a + b, 0) || 1;
  const spec = type === "power" ? POWER_ZONE_RANGES : HR_ZONE_RANGES;

  return (
    <div
      className="app-card-elevated p-5 sm:p-6"
      data-testid={testId || (type === "power" ? "power-zones-chart" : "hr-zones-chart")}
    >
      <div className="card-label">{eyebrow}</div>
      <h3 className="section-title mt-0.5 mb-5">
        {title}
      </h3>

      <div className="space-y-3.5">
        {Object.keys(spec).map((k) => {
          const secs = zones[k] || 0;
          const pct = (secs / total) * 100;
          const z = spec[k];
          const color = ZONE_COLORS[k];
          return (
            <div key={k} data-testid={`${type}-zone-row-${k}`}>
              <div className="flex justify-between items-baseline mb-1">
                <div className="flex items-baseline gap-3 min-w-0">
                  <span
                    className="text-[11px] tracking-widest uppercase whitespace-nowrap"
                    style={{ color }}
                  >
                    {z.label}
                  </span>
                  <span className="text-[10px] font-mono text-dark-text-muted truncate">
                    {z.range}
                  </span>
                </div>
                <span className="font-mono text-xs text-dark-text-secondary whitespace-nowrap">
                  {fmtDuration(secs)}
                  <span className="text-dark-text-muted ml-1">{pct.toFixed(0)}%</span>
                </span>
              </div>
              <div className="h-2.5 rounded-sm bg-[var(--surface-secondary)] border border-[var(--border-primary)] overflow-hidden">
                <div
                  className="h-full transition-all rounded-sm"
                  style={{ width: `${pct}%`, background: color }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
